import React, {useState} from "react";
import styles from './DenyButton.module.scss';
import {IProduct} from 'data/interfaces/products';
import {Button, Divider} from "@material-ui/core";
import {MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBPopover, MDBPopoverBody, MDBPopoverHeader, MDBRow} from 'mdbreact';
import useToggle from '@react-hook/toggle';

export interface IApproveButton {
  product: IProduct;
  cancel: (product_id: number) => void;
}

const DenyButton = (props: IApproveButton) => {
  const [isOn, setIsOn] = useState(false);
  return (
    <MDBPopover
      placement="bottom"
      popover
      clickable
      isVisible={isOn}
      className={styles.DenyButtonPopOverContainer}
    >
      <Button
        variant="contained"
        className={`${styles.actionButtons} ${styles.disapproveButton} editorButtons`}
        onClick={() => setIsOn(true)}
      >סרב</Button>
      <div>
        <MDBPopoverHeader>בטוח לסרב להצעה?</MDBPopoverHeader>
        <MDBPopoverBody>
          <MDBRow>
            <MDBCol>
              <MDBCard color="lighten-1">
                <MDBCardBody>
                  <MDBRow>
                    <MDBCol>
                      אזהרה!
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol>
                      סירוב לאשר את המודעה או אי אישורה בטווח של 48 שעות יגרור את הורדתה מהאתר. (ניתן לפרסם מודעה זו
                      בשנית במועד מאוחר יותר).
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol>
              <Divider style={{marginBottom: 5, marginTop: 5}}/>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol xs="6">
              <MDBBtn color="default" onClick={() => setIsOn(false)}>
                לא
              </MDBBtn>
            </MDBCol>
            <MDBCol xs="6">
              <MDBBtn color="primary"
                      onClick={() => {
                        setIsOn(false);
                        return props.cancel(props.product.id);
                      }}>
                כן
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </MDBPopoverBody>
      </div>
    </MDBPopover>
  )
};

DenyButton.defaultProps = {
  product: {},
};

export default DenyButton;
